"use strict";
(() => {
  var __defProp = Object.defineProperty;
  var __defProps = Object.defineProperties;
  var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols = Object.getOwnPropertySymbols;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __propIsEnum = Object.prototype.propertyIsEnumerable;
  var __pow = Math.pow;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
      for (var prop of __getOwnPropSymbols(b)) {
        if (__propIsEnum.call(b, prop))
          __defNormalProp(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
  var __async = (__this, __arguments, generator) => {
    return new Promise((resolve, reject) => {
      var fulfilled = (value) => {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      };
      var rejected = (value) => {
        try {
          step(generator.throw(value));
        } catch (e) {
          reject(e);
        }
      };
      var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
      step((generator = generator.apply(__this, __arguments)).next());
    });
  };

  // src/scripts/sections/postcode-search.js
  var PSS_NZ_PROVINCE_CODES = {
    Auckland: "AUK",
    "Auckland Region": "AUK",
    "Bay of Plenty": "BOP",
    "Bay of Plenty Region": "BOP",
    Canterbury: "CAN",
    "Canterbury Region": "CAN",
    "Chatham Islands": "CIT",
    "Chatham Islands Territory": "CIT",
    Gisborne: "GIS",
    "Gisborne Region": "GIS",
    "Hawke's Bay": "HKB",
    "Hawke's Bay Region": "HKB",
    "Manawatu-Wanganui": "MWT",
    "Manawat\u016B-Whanganui": "MWT",
    "Manawatu-Whanganui Region": "MWT",
    Marlborough: "MBH",
    "Marlborough Region": "MBH",
    Nelson: "NSN",
    "Nelson Region": "NSN",
    Northland: "NTL",
    "Northland Region": "NTL",
    Otago: "OTA",
    "Otago Region": "OTA",
    Southland: "STL",
    "Southland Region": "STL",
    Taranaki: "TKI",
    "Taranaki Region": "TKI",
    Tasman: "TAS",
    "Tasman Region": "TAS",
    Waikato: "WKO",
    "Waikato Region": "WKO",
    Wellington: "WGN",
    "Wellington Region": "WGN",
    "West Coast": "WTC",
    "West Coast Region": "WTC"
  };
  var PSS_SOUTH_ISLAND_PROVINCES = /* @__PURE__ */ new Set(["CAN", "MBH", "NSN", "OTA", "STL", "TAS", "WTC"]);
  function pssNZIslandKey(region) {
    const code = PSS_NZ_PROVINCE_CODES[region] || region;
    return PSS_SOUTH_ISLAND_PROVINCES.has(code) ? "SI" : "NI";
  }
  var PSS_AU_STATES = {
    NSW: "New South Wales",
    VIC: "Victoria",
    QLD: "Queensland",
    WA: "Western Australia",
    SA: "South Australia",
    TAS: "Tasmania",
    ACT: "Australian Capital Territory",
    NT: "Northern Territory"
  };
  function pssDebounce(fn, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  }
  var PostcodeSearchTWP = class extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("[data-pss-form]");
      if (!this.form) return;
      this.postcodeInput = this.querySelector("[data-pss-postcode]");
      this.titleHeader = this.querySelector("[data-pss-header]");
      this.inputWrap = this.querySelector("[data-pss-input-group]");
      this.textInput = this.querySelector("[data-pss-input]");
      this.clearBtn = this.querySelector("[data-pss-clear]");
      this.suggestions = this.querySelector("[data-pss-suggestions]");
      this.useLocationBtn = this.querySelector("[data-pss-use-location]");
      this.searchHeader = this.querySelector("[data-pss-search-header]");
      this.locationEl = this.querySelector("[data-pss-location]");
      this.resetBtn = this.querySelector("[data-pss-reset]");
      this.results = this.querySelector("[data-pss-results]");
      this.postcodeCache = {};
      this.selectedEntry = null;
      this.cartCookie = this.getCookie("cart");
      this.debouncedSearch = pssDebounce((val) => this.searchPostcodes(val), 300);
      this.init();
    }
    init() {
      var _a, _b, _c, _d;
      this.textInput.addEventListener("input", (e) => {
        const val = e.target.value;
        this.clearBtn.hidden = !val;
        this.selectedEntry = null;
        this.debouncedSearch(val);
      });
      this.textInput.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          const first = this.suggestions.querySelector("[data-pss-suggestion]");
          if (first) {
            first.click();
          }
        }
        if (e.key === "Escape") {
          this.hideSuggestions();
        }
      });
      this.clearBtn.addEventListener("click", () => this.clearResults());
      (_a = this.resetBtn) == null ? void 0 : _a.addEventListener("click", () => this.clearResults());
      this.useLocationBtn.addEventListener("click", () => this.handleUseLocation());
      this.form.addEventListener("submit", (e) => {
        e.preventDefault();
        if (this.selectedEntry) this.handleSubmit();
      });
      document.addEventListener("click", (e) => {
        if (!this.contains(e.target)) this.hideSuggestions();
      });
      (_b = this.results) == null ? void 0 : _b.addEventListener("click", (e) => {
        var _a2;
        if (e.target.closest("[data-pss-view-all-stores]")) {
          (_a2 = document.querySelector("check-in-store-drawer")) == null ? void 0 : _a2.open();
        }
      });
      document.addEventListener("variant:changed", (e) => {
        var _a2;
        const variant = (_a2 = e.detail) == null ? void 0 : _a2.variant;
        if (!variant) return;
        this.form.dataset.pssVariantId = variant.id;
        this.form.dataset.pssVariantSku = variant.sku;
        this.form.dataset.pssVariantPrice = variant.price;
        this.form.dataset.pssVariantRequiresShipping = variant.requires_shipping;
        this.form.dataset.pssVariantTaxable = variant.taxable;
        if (this.selectedEntry) this.handleSubmit();
      });
      const savedPostcode = sessionStorage.getItem("customerPostcode");
      if (savedPostcode) {
        this.textInput.value = sessionStorage.getItem("customerPostcodeLabel") || savedPostcode;
        this.clearBtn.hidden = false;
        if (this.titleHeader) this.titleHeader.hidden = true;
        setTimeout(() => this.restoreSavedPostcode(savedPostcode), 100);
      } else if (!this.isLocationOnly && ((_d = (_c = window.pss) == null ? void 0 : _c.customerAddress) == null ? void 0 : _d.postcode)) {
        const { postcode, suburb, country } = window.pss.customerAddress;
        this.textInput.value = suburb ? `${suburb} ${postcode}` : postcode;
        if (this.titleHeader) this.titleHeader.hidden = true;
        setTimeout(() => this.autoLoadCustomerAddress(postcode, suburb, country), 100);
      }
      document.addEventListener("pss:coords-changed", (e) => {
        if (e.target === this) return;
        const postcode = sessionStorage.getItem("customerPostcode");
        if (!this.isLocationOnly && postcode) {
          this.restoreSavedPostcode(postcode);
        } else {
          this.syncDisplay();
        }
      });
      document.addEventListener("cis:preferred-store-changed", () => {
        if (this.selectedEntry) this.handleSubmit();
      });
    }
    syncDisplay() {
      const postcode = sessionStorage.getItem("customerPostcode");
      const label = sessionStorage.getItem("customerPostcodeLabel") || postcode;
      if (postcode && label) {
        this.textInput.value = label;
        this.clearBtn.hidden = false;
        if (this.titleHeader) this.titleHeader.hidden = true;
        if (this.searchHeader) {
          if (this.locationEl) this.locationEl.textContent = label;
          this.searchHeader.hidden = false;
          this.inputWrap.hidden = true;
          this.useLocationBtn.hidden = true;
        }
      } else {
        this.textInput.value = "";
        this.clearBtn.hidden = true;
        if (this.titleHeader) this.titleHeader.hidden = false;
        if (this.searchHeader) this.searchHeader.hidden = true;
        if (this.results) {
          this.results.hidden = true;
          this.results.innerHTML = "";
        }
        this.inputWrap.hidden = false;
        this.useLocationBtn.hidden = false;
      }
    }
    get isLocationOnly() {
      return this.dataset.mode === "location-only";
    }
    restoreSavedPostcode(zip) {
      return __async(this, null, function* () {
        const entry = yield this.findExactPostcode(zip);
        if (entry) {
          this.selectedEntry = entry;
          this.handleSubmit();
        } else {
          if (this.titleHeader) this.titleHeader.hidden = false;
        }
      });
    }
    autoLoadCustomerAddress(postcode, suburb, country) {
      return __async(this, null, function* () {
        const entry = yield this.findExactPostcode(postcode);
        this.selectedEntry = entry || { postcode, suburb: suburb || "", region: "", country: country || "NZ", lat: null, lng: null };
        this.textInput.value = suburb ? `${suburb} ${postcode}` : postcode;
        this.clearBtn.hidden = false;
        this.handleSubmit();
      });
    }
    // ─── Search & suggestions ────────────────────────────────────────────────
    searchPostcodes(query) {
      return __async(this, null, function* () {
        var _a;
        const q = query.trim();
        if (q.length < 2) {
          this.hideSuggestions();
          return;
        }
        const isNumeric = /^\d+$/.test(q);
        const qLower = q.toLowerCase();
        const nzResults = [];
        const auResults = [];
        for (const country of ["NZ", "AU"]) {
          const list = yield this.loadPostcodeFile(country);
          if (!list) continue;
          const bucket = country === "NZ" ? nzResults : auResults;
          for (const item of list) {
            if (bucket.length >= 6) break;
            if (isNumeric) {
              if (String(item.postcode).startsWith(q)) {
                bucket.push(__spreadProps(__spreadValues({}, item), { country }));
              }
            } else {
              const suburb = (item.suburb || item.region || "").toLowerCase();
              if (suburb.includes(qLower)) {
                bucket.push(__spreadProps(__spreadValues({}, item), { country }));
              }
            }
          }
        }
        const results = [...nzResults, ...auResults.slice(0, Math.max(0, 8 - nzResults.length))];
        if (!results.length) {
          const fallback = (_a = window.pss) == null ? void 0 : _a.internationalFallback;
          if (fallback == null ? void 0 : fallback.text) {
            this.renderFallback(fallback);
          } else {
            this.hideSuggestions();
          }
          return;
        }
        this.renderSuggestions(results);
      });
    }
    loadPostcodeFile(country) {
      return __async(this, null, function* () {
        var _a, _b;
        if (this.postcodeCache[country]) return this.postcodeCache[country];
        const url = (_b = (_a = window.pss) == null ? void 0 : _a.postcodes) == null ? void 0 : _b[country];
        if (!url) return null;
        try {
          const res = yield fetch(url);
          if (!res.ok) return null;
          const list = yield res.json();
          this.postcodeCache[country] = list;
          return list;
        } catch (e) {
          return null;
        }
      });
    }
    findExactPostcode(zip) {
      return __async(this, null, function* () {
        var _a, _b;
        for (const country of ["NZ", "AU"]) {
          const list = yield this.loadPostcodeFile(country);
          if (!list) continue;
          const match = list.find((item) => String(item.postcode) === String(zip));
          if (match) {
            const region = match.region || match.state || "";
            return __spreadProps(__spreadValues({}, match), { region, country, lng: (_b = (_a = match.long) != null ? _a : match.lng) != null ? _b : null });
          }
        }
        return null;
      });
    }
    renderSuggestions(results) {
      if (!results.length) {
        this.hideSuggestions();
        return;
      }
      this.suggestions.innerHTML = results.map((item) => {
        var _a, _b, _c;
        const suburb = item.suburb || item.region || "";
        const region = item.region || item.state || "";
        const parts = [suburb];
        if (region && region !== suburb) parts.push(region);
        parts.push(item.postcode);
        const label = parts.join(" ");
        return `<button
        type="button"
        class="pss__suggestion"
        data-pss-suggestion
        data-postcode="${item.postcode}"
        data-suburb="${suburb}"
        data-region="${region}"
        data-country="${item.country}"
        data-lat="${(_a = item.lat) != null ? _a : ""}"
        data-lng="${(_c = (_b = item.long) != null ? _b : item.lng) != null ? _c : ""}"
      >${label}</button>`;
      }).join("");
      this.suggestions.querySelectorAll("[data-pss-suggestion]").forEach((btn) => {
        btn.addEventListener("click", () => {
          this.selectSuggestion(btn.dataset);
        });
      });
      this.suggestions.hidden = false;
      this.querySelector(".pss__input-wrap").classList.add("pss__input-wrap--open");
    }
    hideSuggestions() {
      var _a;
      this.suggestions.hidden = true;
      this.suggestions.innerHTML = "";
      (_a = this.querySelector(".pss__input-wrap")) == null ? void 0 : _a.classList.remove("pss__input-wrap--open");
    }
    renderFallback({ text, url }) {
      const inner = url ? `<a href="${url}" class="pss__fallback-link">${text}</a>` : `<span>${text}</span>`;
      this.suggestions.innerHTML = `<div class="pss__fallback">${inner}</div>`;
      this.suggestions.hidden = false;
      this.querySelector(".pss__input-wrap").classList.add("pss__input-wrap--open");
    }
    selectSuggestion(data) {
      const { postcode, suburb, country } = data;
      const rawRegion = data.region || "";
      const region = country === "AU" ? PSS_AU_STATES[rawRegion] || rawRegion : rawRegion;
      const displaySuburb = suburb || rawRegion;
      this.textInput.value = `${displaySuburb} ${postcode}`;
      this.postcodeInput.value = postcode;
      this.clearBtn.hidden = false;
      this.hideSuggestions();
      this.selectedEntry = {
        postcode,
        suburb: displaySuburb,
        region,
        country,
        lat: data.lat ? parseFloat(data.lat) : null,
        lng: data.lng ? parseFloat(data.lng) : null
      };
      this.handleSubmit();
    }
    // ─── Submit & results ────────────────────────────────────────────────────
    // Locale key for looking up delivery messaging config: 'AU', or for NZ the
    // customer's island ('NI' / 'SI') based on their selected region.
    getConfigLocale() {
      const entry = this.selectedEntry;
      if (!entry) return "NI";
      if (entry.country === "AU") return "AU";
      return pssNZIslandKey(entry.region);
    }
    setLoading(isLoading) {
      if (isLoading) {
        this.classList.add("pss--loading");
        this.textInput.disabled = true;
      } else {
        this.classList.remove("pss--loading");
        this.textInput.disabled = false;
      }
    }
    clearResults() {
      this.selectedEntry = null;
      this.postcodeInput.value = "";
      this.textInput.value = "";
      this.clearBtn.hidden = true;
      this.hideSuggestions();
      if (this.titleHeader) this.titleHeader.hidden = false;
      if (this.searchHeader) this.searchHeader.hidden = true;
      if (this.results) {
        this.results.hidden = true;
        this.results.innerHTML = "";
      }
      const countdownEl = this.querySelector("[data-pss-countdown]");
      if (countdownEl) countdownEl.hidden = true;
      this.inputWrap.hidden = false;
      this.useLocationBtn.hidden = false;
      sessionStorage.removeItem("customerPostcode");
      sessionStorage.removeItem("customerPostcodeLabel");
      sessionStorage.removeItem("customerCountry");
      sessionStorage.removeItem("customerProvince");
      sessionStorage.removeItem("customerConfigLocale");
      sessionStorage.removeItem("customerCoords");
      this.dispatchEvent(new CustomEvent("pss:coords-changed", { bubbles: true, detail: null }));
      this.textInput.focus();
    }
    handleSubmit() {
      return __async(this, null, function* () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i;
        if (!this.selectedEntry) return;
        this.setLoading(true);
        if (this.titleHeader) this.titleHeader.hidden = true;
        const { postcode, suburb, region, country } = this.selectedEntry;
        const province = country === "AU" ? PSS_AU_STATES[region] || region : region;
        sessionStorage.setItem("customerPostcode", postcode);
        sessionStorage.setItem("customerPostcodeLabel", suburb ? `${suburb} ${postcode}` : postcode);
        sessionStorage.setItem("customerCountry", country);
        sessionStorage.setItem("customerProvince", province);
        const configLocale = this.getConfigLocale();
        sessionStorage.setItem("customerConfigLocale", configLocale);
        const { lat, lng } = this.selectedEntry;
        if (lat != null && lng != null) {
          sessionStorage.setItem("customerCoords", JSON.stringify({ lat, lng }));
        } else {
          sessionStorage.removeItem("customerCoords");
        }
        this.dispatchEvent(new CustomEvent("pss:coords-changed", { bubbles: true, detail: { lat, lng, postcode } }));
        if (this.isLocationOnly) {
          this.setLoading(false);
          return;
        }
        const variant = {
          id: (_a = this.form.dataset.pssVariantId) != null ? _a : "",
          sku: (_b = this.form.dataset.pssVariantSku) != null ? _b : "",
          price: (_c = this.form.dataset.pssVariantPrice) != null ? _c : "",
          grams: (_d = this.form.dataset.pssVariantWeight) != null ? _d : "",
          requires_shipping: (_e = this.form.dataset.pssVariantRequiresShipping) != null ? _e : "",
          taxable: (_f = this.form.dataset.pssVariantTaxable) != null ? _f : "",
          product: {
            id: (_g = this.form.dataset.pssProductId) != null ? _g : "",
            vendor: (_h = this.form.dataset.pssProductVendor) != null ? _h : ""
          }
        };
        const cannotShip = this.form.hasAttribute("data-pss-cannot-ship");
        const storeAvailabilityPromise = this.getStoreAvailability(variant.id);
        const bespokeData = yield this.getBespokeRates(variant, country, province, postcode, cannotShip);
        const shopifyRates = yield this.getShopifyRates(variant.id, postcode, country, region);
        const storeAvailability = yield storeAvailabilityPromise;
        const nearestStore = this.findNearestStore(storeAvailability);
        const preferredStore = this.getPreferredStore(storeAvailability);
        const deliveryMethods = bespokeData ? this.getDeliveryMethods(bespokeData, configLocale) : [];
        if (!deliveryMethods.length && !shopifyRates.length && !nearestStore && !preferredStore && !((_i = window.pss) == null ? void 0 : _i.clickAndCollect)) {
          this.renderError("Unable to load delivery information. Please try again.");
          this.setLoading(false);
          return;
        }
        this.renderResults(deliveryMethods, shopifyRates, suburb, postcode, nearestStore, preferredStore);
        this.setLoading(false);
      });
    }
    handleUseLocation() {
      return __async(this, null, function* () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i;
        if (!navigator.geolocation) return;
        this.setLoading(true);
        this.useLocationBtn.hidden = true;
        try {
          const position = yield new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject, { timeout: 1e4 });
          });
          const { latitude, longitude } = position.coords;
          const res = yield fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`,
            { headers: { "Accept-Language": "en" } }
          );
          const data = yield res.json();
          const postcode = (_b = (_a = data == null ? void 0 : data.address) == null ? void 0 : _a.postcode) == null ? void 0 : _b.replace(/\s/g, "").slice(0, 4);
          if (postcode) {
            const entry = yield this.findExactPostcode(postcode);
            const suburb = (entry == null ? void 0 : entry.suburb) || ((_c = data == null ? void 0 : data.address) == null ? void 0 : _c.suburb) || ((_d = data == null ? void 0 : data.address) == null ? void 0 : _d.neighbourhood) || ((_e = data == null ? void 0 : data.address) == null ? void 0 : _e.quarter) || ((_f = data == null ? void 0 : data.address) == null ? void 0 : _f.town) || ((_g = data == null ? void 0 : data.address) == null ? void 0 : _g.city) || "";
            const region = (entry == null ? void 0 : entry.region) || ((_h = data == null ? void 0 : data.address) == null ? void 0 : _h.county) || ((_i = data == null ? void 0 : data.address) == null ? void 0 : _i.state) || "";
            const country = (entry == null ? void 0 : entry.country) || "NZ";
            if (suburb || entry) {
              this.textInput.value = suburb ? `${suburb} ${postcode}` : postcode;
              this.postcodeInput.value = postcode;
              this.clearBtn.hidden = false;
              this.selectedEntry = { postcode, suburb, region, country, lat: latitude, lng: longitude };
              this.setLoading(false);
              this.handleSubmit();
              return;
            }
          }
        } catch (e) {
        }
        this.setLoading(false);
        this.useLocationBtn.hidden = false;
      });
    }
    renderResults(deliveryMethods, shopifyRates, suburb, zip, nearestStore = null, preferredStore = null) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
      const locationText = suburb ? `${suburb}, ${zip}` : zip;
      this.locationEl.textContent = locationText;
      this.titleHeader.hidden = true;
      this.inputWrap.hidden = true;
      this.useLocationBtn.hidden = true;
      this.searchHeader.hidden = false;
      const country = (_a = this.selectedEntry) == null ? void 0 : _a.country;
      const isNZ = country === "NZ";
      const configLocale = this.getConfigLocale();
      const nzHour = this.getNZHour();
      const uberCutoff = (_c = (_b = window.pss) == null ? void 0 : _b.uberCutoffHour) != null ? _c : 14;
      const ccCutoff = (_e = (_d = window.pss) == null ? void 0 : _d.ccCutoffHour) != null ? _e : 16;
      const uberDistKm = (_g = (_f = window.pss) == null ? void 0 : _f.uberDistanceKm) != null ? _g : 10;
      const ccDistKm = (_i = (_h = window.pss) == null ? void 0 : _h.ccDistanceKm) != null ? _i : 30;
      const nearestInStock = (nearestStore == null ? void 0 : nearestStore.store.available) ? nearestStore : null;
      const nearestInStockDist = (_j = nearestInStock == null ? void 0 : nearestInStock.distance) != null ? _j : null;
      const showUber = isNZ && nzHour < uberCutoff && nearestInStock !== null && (nearestInStockDist === null || nearestInStockDist <= uberDistKm);
      const showCC = isNZ && nearestInStock !== null && (nearestInStockDist === null || nearestInStockDist <= ccDistKm);
      const displayStore = preferredStore || nearestStore;
      const showStoreBlock = displayStore !== null && (preferredStore !== null || showCC);
      const afterCCCutoff = isNZ && nzHour >= ccCutoff;
      const bespokeNames = new Set(deliveryMethods.map((m) => m.name.trim().toLowerCase()));
      const filteredShopifyRates = shopifyRates.filter((r) => !bespokeNames.has(r.name.trim().toLowerCase()));
      const themeOptions = (_k = window.pss) == null ? void 0 : _k.deliveryOptions;
      const moneyFormat = ((_l = window.pss) == null ? void 0 : _l.moneyFormat) || "${{amount}}";
      const variantPriceCents = parseFloat(this.form.dataset.pssVariantPrice || "0");
      const resolveBadge = (opt, ctry) => {
        var _a2, _b2;
        const badgeText = ((_a2 = opt.badge) == null ? void 0 : _a2[ctry]) || null;
        if (!badgeText) return null;
        const threshold = (_b2 = opt.badgeThreshold) == null ? void 0 : _b2[ctry];
        if (threshold != null && variantPriceCents >= threshold * 100) return null;
        return badgeText;
      };
      const enrichedShopifyRates = filteredShopifyRates.map((r) => {
        var _a2, _b2;
        const themeRate = themeOptions == null ? void 0 : themeOptions.find(
          (opt) => r.name.trim().toLowerCase().includes(opt.name.trim().toLowerCase())
        );
        if (!themeRate) return { isEnriched: false, rate: r };
        const amount = parseFloat(r.price);
        return {
          isEnriched: true,
          method: {
            name: themeRate.name,
            logo: themeRate.logoDark || themeRate.logo || null,
            eta: ((_a2 = themeRate.eta) == null ? void 0 : _a2[configLocale]) || null,
            priceMessage: ((_b2 = themeRate.defaultPriceMessage) == null ? void 0 : _b2[configLocale]) || (amount === 0 ? "FREE" : this.formatMoney(amount * 100, moneyFormat, null)),
            badge: resolveBadge(themeRate, configLocale),
            isSameDay: !!themeRate.isSameDay
          }
        };
      });
      const visibleDeliveryMethods = deliveryMethods.filter((m) => !m.isSameDay || showUber);
      const visibleShopifyRates = enrichedShopifyRates.filter(
        (item) => !item.isEnriched || !item.method.isSameDay || showUber
      );
      const coveredSameDay = /* @__PURE__ */ new Set([
        ...visibleDeliveryMethods.filter((m) => m.isSameDay).map((m) => m.name.trim().toLowerCase()),
        ...visibleShopifyRates.filter((i) => i.isEnriched && i.method.isSameDay).map((i) => i.method.name.trim().toLowerCase())
      ]);
      let sameDayHtml = "";
      if (showUber) {
        const nzNow = new Date((/* @__PURE__ */ new Date()).toLocaleString("en-US", { timeZone: "Pacific/Auckland" }));
        const minutesLeft = uberCutoff * 60 - (nzNow.getHours() * 60 + nzNow.getMinutes());
        const hrs = Math.floor(minutesLeft / 60);
        const mins = minutesLeft % 60;
        const timeStr = hrs > 0 ? `${hrs}hr${mins > 0 ? ` ${mins} min` : ""}` : `${mins} min`;
        const countdownEl = this.querySelector("[data-pss-countdown]");
        const countdownText = this.querySelector("[data-pss-countdown-text]");
        if (countdownEl && countdownText) {
          const template = ((_m = window.pss) == null ? void 0 : _m.countdownTemplate) || "Order in the next {time} for same-day delivery";
          countdownText.innerHTML = template.replace("{time}", `<strong>${timeStr}</strong>`);
          countdownEl.hidden = false;
        }
        sameDayHtml = (((_n = window.pss) == null ? void 0 : _n.deliveryOptions) || []).filter((opt) => opt.isSameDay && !coveredSameDay.has(opt.name.trim().toLowerCase())).map((opt) => {
          var _a2, _b2;
          return this.renderDeliveryItem({
            name: opt.name,
            priceMessage: ((_a2 = opt.defaultPriceMessage) == null ? void 0 : _a2[configLocale]) || "Price calculated at checkout",
            eta: ((_b2 = opt.eta) == null ? void 0 : _b2[configLocale]) || null,
            badge: resolveBadge(opt, configLocale),
            logo: opt.logoDark || opt.logo || null
          });
        }).join("");
      } else {
        const countdownEl = this.querySelector("[data-pss-countdown]");
        if (countdownEl) countdownEl.hidden = true;
      }
      let html = sameDayHtml;
      html += visibleDeliveryMethods.map((m) => this.renderDeliveryItem(m)).join("");
      html += visibleShopifyRates.map((item) => item.isEnriched ? this.renderDeliveryItem(item.method) : this.renderShopifyRateItem(item.rate)).join("");
      const cc = (_o = window.pss) == null ? void 0 : _o.clickAndCollect;
      if (cc && showCC) {
        html += this.renderDeliveryItem({
          name: "Click & Collect",
          priceMessage: cc.priceMessage || "FREE",
          eta: afterCCCutoff ? cc.etaAfterCutoff || null : cc.eta || null,
          badge: afterCCCutoff ? cc.badgeAfterCutoff || "Collect Tomorrow" : cc.badge || null,
          logo: null
        });
      }
      if (showStoreBlock) {
        html += this.renderNearestStore(displayStore);
      }
      if (!html) {
        html = `<li class="pss__result-item"><p class="pss__empty">No delivery options found for this postcode.</p></li>`;
      }
      this.results.innerHTML = html;
      this.results.hidden = false;
    }
    getNZHour() {
      return parseInt(
        new Intl.DateTimeFormat("en-NZ", { timeZone: "Pacific/Auckland", hour: "numeric", hour12: false }).format(/* @__PURE__ */ new Date()),
        10
      );
    }
    renderDeliveryItem(method) {
      const { name, priceMessage, eta, badge, logo } = method;
      let html = `<li class="pss__result-item">`;
      html += `<div class="pss__result-row">`;
      html += `<div class="pss__result-left"><span class="pss__status-dot pss__status-dot--available" aria-hidden="true"></span><span class="pss__result-name">${name}</span></div>`;
      if (priceMessage) html += `<span class="pss__result-price">${priceMessage}</span>`;
      html += `</div>`;
      if (logo || eta || badge) {
        html += `<div class="pss__result-row pss__result-row--sub">`;
        if (logo) html += `<img class="pss__result-logo" src="${logo}" alt="" loading="lazy">`;
        if (eta) html += `<span class="pss__result-eta">${eta}</span>`;
        if (badge) html += `<span class="pss__result-badge">${badge}</span>`;
        html += `</div>`;
      }
      html += `</li>`;
      return html;
    }
    renderShopifyRateItem(rate) {
      var _a;
      const name = rate.name;
      const amount = parseFloat(rate.price);
      const moneyFormat = ((_a = window.pss) == null ? void 0 : _a.moneyFormat) || "${{amount}}";
      const priceMessage = amount === 0 ? "FREE" : this.formatMoney(amount * 100, moneyFormat, null);
      let html = `<li class="pss__result-item">`;
      html += `<div class="pss__result-row">`;
      html += `<div class="pss__result-left"><span class="pss__status-dot pss__status-dot--available" aria-hidden="true"></span><span class="pss__result-name">${name}</span></div>`;
      html += `<span class="pss__result-price">${priceMessage}</span>`;
      html += `</div></li>`;
      return html;
    }
    renderError(message) {
      this.titleHeader.hidden = false;
      this.inputWrap.hidden = false;
      this.useLocationBtn.hidden = false;
      this.searchHeader.hidden = true;
      this.results.innerHTML = `<li class="pss__result-item"><p class="pss__empty pss__empty--error">${message}</p></li>`;
      this.results.hidden = false;
    }
    // ─── Shopify AJAX rates ───────────────────────────────────────────────────
    getShopifyRates(variantId, zip, countryCode, provinceCode) {
      return __async(this, null, function* () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const token = (_a = window.pss) == null ? void 0 : _a.storefrontToken;
        if (!token) {
          console.warn(
            'PSS | storefrontToken not configured \u2014 skipping Shopify rates. Add it under the block "Storefront API token" setting.'
          );
          return [];
        }
        const gid = `gid://shopify/ProductVariant/${variantId}`;
        const mutation = `
      mutation cartCreate($input: CartInput!) {
        cartCreate(input: $input) {
          cart {
            deliveryGroups(first: 10) {
              edges {
                node {
                  deliveryOptions {
                    title
                    estimatedCost { amount currencyCode }
                  }
                }
              }
            }
          }
          userErrors { field message }
        }
      }
    `;
        const resolvedProvinceCode = PSS_NZ_PROVINCE_CODES[provinceCode] || provinceCode;
        const variables = {
          input: {
            lines: [{ merchandiseId: gid, quantity: 1 }],
            delivery: {
              addresses: [
                {
                  selected: true,
                  address: {
                    deliveryAddress: { zip: String(zip), countryCode, provinceCode: resolvedProvinceCode }
                  }
                }
              ]
            }
          }
        };
        try {
          const res = yield fetch("/api/2026-01/graphql.json", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": token
            },
            body: JSON.stringify({ query: mutation, variables })
          });
          const data = yield res.json();
          const errors = (_c = (_b = data == null ? void 0 : data.data) == null ? void 0 : _b.cartCreate) == null ? void 0 : _c.userErrors;
          if (errors == null ? void 0 : errors.length) {
            console.warn("PSS | cartCreate errors", errors);
            return [];
          }
          const edges = (_h = (_g = (_f = (_e = (_d = data == null ? void 0 : data.data) == null ? void 0 : _d.cartCreate) == null ? void 0 : _e.cart) == null ? void 0 : _f.deliveryGroups) == null ? void 0 : _g.edges) != null ? _h : [];
          return edges.flatMap(
            (e) => {
              var _a2, _b2;
              return ((_b2 = (_a2 = e.node) == null ? void 0 : _a2.deliveryOptions) != null ? _b2 : []).map((opt) => {
                var _a3, _b3;
                return {
                  name: opt.title,
                  price: (_b3 = (_a3 = opt.estimatedCost) == null ? void 0 : _a3.amount) != null ? _b3 : "0"
                };
              });
            }
          );
        } catch (err) {
          console.warn("PSS | Shopify SF rates failed", err);
          return [];
        }
      });
    }
    // ─── Bespoke API ─────────────────────────────────────────────────────────
    getBespokeRates(variant, country, province, zip, cannotShip) {
      return __async(this, null, function* () {
        var _a, _b;
        const token = (_a = window.pss) == null ? void 0 : _a.token;
        if (!token) {
          console.error("PSS | Bespoke API token not configured.");
          return null;
        }
        const query = {
          origin: {
            country: "",
            postal_code: "",
            province: "",
            city: "",
            name: "",
            address1: "",
            address2: "",
            address3: "",
            phone: "",
            fax: "",
            address_type: "",
            company_name: ""
          },
          destination: {
            country,
            postal_code: zip,
            province,
            city: "",
            name: "",
            address1: "",
            address2: "",
            address3: "",
            phone: "",
            fax: "",
            address_type: "",
            company_name: ""
          },
          items: [
            {
              sku: variant.sku,
              quantity: 1,
              price: variant.price,
              vendor: variant.product.vendor,
              requires_shipping: variant.requires_shipping,
              taxable: variant.taxable,
              fulfillment_service: "manual",
              properties: "",
              product_id: variant.product.id,
              variant_id: variant.id
            }
          ],
          currency: ((_b = Shopify.shop) == null ? void 0 : _b.currency) || "NZD"
        };
        try {
          const response = yield fetch("https://parcel-intelligence.com/cs/api_ex.php", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              HTTP_X_STORE_NAME: Shopify.shop,
              HTTP_X_STORE_TOKEN: token,
              HTTP_X_SHOW_DEBUG: "true"
            },
            body: JSON.stringify(query)
          });
          if (!response.ok) {
            console.error("PSS | Bespoke API error", response.status);
            return null;
          }
          const text = yield response.text();
          const lines = text.trim().split("\n");
          const data = JSON.parse(lines[lines.length - 1]);
          const shippingRateData = data.rates.filter((r) => {
            var _a2;
            const code = r == null ? void 0 : r.service_code;
            if (!code) return false;
            if (code.startsWith("DONOTSELECT")) return false;
            if (code.startsWith("PICKUP_")) return false;
            if (cannotShip && ((_a2 = r == null ? void 0 : r.service_name) == null ? void 0 : _a2.toLowerCase().includes("shipping"))) return false;
            return true;
          }).sort((a, b) => {
            var _a2, _b2, _c, _d;
            const aName = (_b2 = (_a2 = a.service_name) == null ? void 0 : _a2.toLowerCase()) != null ? _b2 : "";
            const bName = (_d = (_c = b.service_name) == null ? void 0 : _c.toLowerCase()) != null ? _d : "";
            const aIsShipping = aName.includes("shipping");
            const bIsShipping = bName.includes("shipping");
            if (aIsShipping && !bIsShipping) return -1;
            if (!aIsShipping && bIsShipping) return 1;
            if (aIsShipping && bIsShipping) return (a.total_price || 0) - (b.total_price || 0);
            return aName.localeCompare(bName);
          });
          return { delivery: shippingRateData };
        } catch (err) {
          console.error("PSS | getBespokeRates failed", err);
          return null;
        }
      });
    }
    getDeliveryMethods(bespokeData, locale) {
      var _a, _b, _c;
      if (!((_a = bespokeData == null ? void 0 : bespokeData.delivery) == null ? void 0 : _a.length)) return [];
      const themeOptions = (_b = window.pss) == null ? void 0 : _b.deliveryOptions;
      const moneyFormat = ((_c = window.pss) == null ? void 0 : _c.moneyFormat) || "${{amount}}";
      return bespokeData.delivery.reduce((prev, curr) => {
        var _a2, _b2, _c2;
        const { service_name: serviceName, total_price: totalPrice, currency } = curr;
        if (!serviceName) return prev;
        let name = serviceName;
        let eta = null;
        let priceMessage = null;
        let badge = null;
        let logo = null;
        let isSameDay = false;
        if (themeOptions == null ? void 0 : themeOptions.length) {
          const themeRate = themeOptions.find(
            (opt) => serviceName.trim().toLowerCase().includes(opt.name.trim().toLowerCase())
          );
          if (themeRate) {
            name = themeRate.name;
            logo = themeRate.logo || null;
            eta = ((_a2 = themeRate.eta) == null ? void 0 : _a2[locale]) || null;
            priceMessage = ((_b2 = themeRate.defaultPriceMessage) == null ? void 0 : _b2[locale]) || this.formatMoney(totalPrice, moneyFormat, currency);
            badge = ((_c2 = themeRate.badge) == null ? void 0 : _c2[locale]) || null;
            isSameDay = !!themeRate.isSameDay;
          } else {
            priceMessage = this.formatMoney(totalPrice, moneyFormat, currency);
          }
        } else {
          priceMessage = this.formatMoney(totalPrice, moneyFormat, currency);
        }
        return [...prev, { name, eta, priceMessage, badge, logo, isSameDay }];
      }, []);
    }
    // ─── Store availability ───────────────────────────────────────────────────
    getStoreAvailability(variantId) {
      return __async(this, null, function* () {
        var _a, _b, _c, _d, _e;
        const token = (_a = window.pss) == null ? void 0 : _a.storefrontToken;
        if (!token) return [];
        const gid = `gid://shopify/ProductVariant/${variantId}`;
        const query = `{
      node(id: "${gid}") {
        ... on ProductVariant {
          storeAvailability(first: 20) {
            edges {
              node {
                available
                pickUpTime
                location { name address { formatted latitude longitude } }
              }
            }
          }
        }
      }
    }`;
        try {
          const res = yield fetch("/api/2026-01/graphql.json", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": token
            },
            body: JSON.stringify({ query })
          });
          const data = yield res.json();
          return ((_e = (_d = (_c = (_b = data == null ? void 0 : data.data) == null ? void 0 : _b.node) == null ? void 0 : _c.storeAvailability) == null ? void 0 : _d.edges) == null ? void 0 : _e.map((e) => e.node)) || [];
        } catch (e) {
          return [];
        }
      });
    }
    // Nearest in-stock store by postcode distance. Drives Uber/Click & Collect eligibility,
    // so it must never be swapped out for the customer's preferred store (see getPreferredStore).
    findNearestStore(stores) {
      const { lat, lng } = this.selectedEntry || {};
      const inStock = stores.filter((s) => s.available);
      if (!inStock.length) return null;
      if (lat == null || lng == null) return { store: inStock[0], distance: null };
      let nearest = null;
      let minDist = Infinity;
      for (const store of inStock) {
        const { latitude, longitude } = store.location.address;
        if (latitude == null || longitude == null) continue;
        const dist = this.haversineKm(lat, lng, latitude, longitude);
        if (dist < minDist) {
          minDist = dist;
          nearest = store;
        }
      }
      return nearest ? { store: nearest, distance: minDist } : { store: inStock[0], distance: null };
    }
    // Customer's "Set as Your Store" pick, surfaced even if out of stock, for the "Your Store"
    // display block only. Must not feed Uber/CC eligibility (that's postcode-based, see findNearestStore).
    getPreferredStore(stores) {
      const { lat, lng } = this.selectedEntry || {};
      const preferredName = localStorage.getItem("cisPreferredStore");
      if (!preferredName) return null;
      const preferred = stores.find((s) => s.location.name === preferredName);
      if (!preferred) return null;
      const { latitude, longitude } = preferred.location.address;
      const distance = lat != null && lng != null && latitude != null && longitude != null ? this.haversineKm(lat, lng, latitude, longitude) : null;
      return { store: preferred, distance };
    }
    haversineKm(lat1, lng1, lat2, lng2) {
      const R = 6371;
      const dLat = (lat2 - lat1) * Math.PI / 180;
      const dLng = (lng2 - lng1) * Math.PI / 180;
      const a = __pow(Math.sin(dLat / 2), 2) + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * __pow(Math.sin(dLng / 2), 2);
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }
    renderNearestStore({ store, distance }) {
      const { location } = store;
      const available = store.available;
      const address = Array.isArray(location.address.formatted) ? location.address.formatted.join(", ") : "";
      const distanceText = distance != null ? `${distance.toFixed(1)}KM Away` : null;
      const stockLabel = available ? "In Stock Now" : "Out of Stock";
      const stockParts = [stockLabel, distanceText].filter(Boolean);
      const dotClass = available ? "pss__status-dot--available" : "pss__status-dot--oos";
      const mapsUrl = `https://maps.google.com/?q=${encodeURIComponent(address)}`;
      let html = `<li class="pss__result-item pss__result-item--store">`;
      html += `<div class="pss__store-details">`;
      html += `<div class="pss__result-row"><div class="pss__result-left"><span class="pss__status-dot ${dotClass}" aria-hidden="true"></span><span class="pss__result-name">${location.name}</span></div></div>`;
      html += `<div class="pss__result-row pss__result-row--sub"><span class="pss__result-eta">${stockParts.join(" | ")}</span><span class="pss__result-badge">Your Store</span></div>`;
      html += `</div>`;
      html += `<div class="pss__store-actions">`;
      html += `<a class="pss__store-link" href="${mapsUrl}" target="_blank" rel="noopener">Directions</a>`;
      html += `<button type="button" class="pss__store-link" data-pss-view-all-stores>View All Stores</button>`;
      html += `</div>`;
      html += `</li>`;
      return html;
    }
    // ─── Utilities ───────────────────────────────────────────────────────────
    formatMoney(cents, format, currency) {
      if (typeof cents !== "number") cents = Number(cents) || 0;
      const amount = (cents / 100).toFixed(2).replace(/\.00$/, "");
      let str = (format || "${{amount}}").replace(/\{\{[\s]*amount[\s]*\}\}/g, amount);
      if (currency) str += ` ${currency}`;
      return str;
    }
    getCookie(name) {
      const value = "; " + document.cookie;
      const parts = value.split("; " + name + "=");
      if (parts.length === 2) return parts.pop().split(";").shift();
    }
    updateCartCookie(value) {
      const expires = new Date(Date.now() + 14 * 864e5).toGMTString();
      document.cookie = `cart=${value}; expires=${expires}; path=/`;
    }
    resetCartCookie() {
      if (this.cartCookie) this.updateCartCookie(this.cartCookie);
    }
  };
  if (!customElements.get("postcode-search-twp")) {
    customElements.define("postcode-search-twp", PostcodeSearchTWP);
  }
})();
